import React from "react"
import request from "../util/request"
import SearchBar from "../legacy_components/SearchBar"
import webify from "../util/webify"

export default class PassengerSearch extends React.Component {
  constructor(props) {
    super(props)
  }

  performLookup = (query) => {
    return request("POST", this.props.searchEndpointPath, {q: query})
  }

  renderSearchResultRow = (r, _resetSearchState) => {
    if (this.props.showTenant) {
      return this.renderTenantSearchResultRow(r)
    }

    return (
      <a
        className="block px-2 py-2 hover:no-underline hover:bg-gray-100"
        key={`${r.user_id}-${r.person_id}`}
        href={r.result_url}
        data-role="search-result-link"
      >
        <div className="font-bold">{r.person_full_name || r.email}</div>
        <div className="inline-block text-gray-700">{r.email}</div>
      </a>
    )
  }

  renderTenantSearchResultRow = (r) => {
    return (
      <a
        className="flex items-center gap-3 px-2 py-2 hover:no-underline hover:bg-gray-100"
        key={`${r.user_id}-${r.person_id}-${r.result_url}`}
        href={r.result_url}
        data-role="search-result-link"
      >
        {this.renderTenantLogo(r)}
        <div className="min-w-0">
          <div className="font-bold">{r.person_full_name || r.email}</div>
          <div className="text-gray-700">{r.email}</div>
        </div>
      </a>
    )
  }

  renderTenantLogo = (r) => {
    if (r.tenant_logo_url) {
      return (
        <img
          src={r.tenant_logo_url}
          alt={r.tenant_name}
          title={r.tenant_name}
          className="flex-shrink-0 w-16 h-10 object-contain"
          loading="lazy"
        />
      )
    }

    return (
      <div
        title={r.tenant_name}
        className="flex flex-shrink-0 items-center justify-center w-16 h-10 rounded bg-gray-100 font-bold text-gray-700"
      >
        {tenantInitials(r.tenant_name)}
      </div>
    )
  }

  render() {
    return (
      <div className="search-bar">
        <SearchBar
          renderSearchResultRow={this.renderSearchResultRow}
          performLookup={this.performLookup}
          placeholder={this.props.placeholder || "Passenger Search..."}
        />
      </div>
    )
  }
}

const tenantInitials = (tenantName) =>
  tenantName
    .split(/\s+/)
    .filter((word) => /^[a-z0-9]/i.test(word))
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("")

webify("passenger-search", PassengerSearch)
